import { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';

export const breadcrumbsContainerSx: SxProps<Theme> = {
  display: 'flex',
  marginLeft: '0.25rem',
  marginTop: '0.25rem',
  marginBottom: '0.25rem',
  flexWrap: 'wrap',
};

export const breadcrumbItemSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
};

export const breadcrumbLabelSx = (isLast: boolean): SxProps<Theme> => ({
  p: '0.5em',
  borderRadius: '4px',
  fontWeight: isLast ? 800 : 400,
  fontSize: '0.875rem',
  fontFamily: 'Archivo',
  cursor: 'pointer',
  mt: '0.25em',
  mb: '0.25em',
});

export const breadcrumbsSeparatorSx: SxProps<Theme> = {
  color: Color.lightGray,
};
